import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-cy": "notificationList",
  class: "mt-1"
}
const _hoisted_2 = { class: "flex items-start justify-between" }
const _hoisted_3 = { class: "w-[60%]" }
const _hoisted_4 = { class: "text-lg overflow-x-auto" }
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "flex flex-col items-center" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "text-sm mt-1" }
const _hoisted_15 = { class: "absolute bottom-1 right-4 text-xs" }
const _hoisted_16 = {
  key: 1,
  class: "text-center text-xl"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_confirm_modal = _resolveComponent("confirm-modal")!
  const _component_status_modal = _resolveComponent("status-modal")!
  const _component_notification_page_skeleton = _resolveComponent("notification-page-skeleton")!
  const _component_standart_template = _resolveComponent("standart-template")!

  return (_openBlock(), _createBlock(_component_standart_template, null, {
    default: _withCtx(() => [
      (_ctx.isLoadData && _ctx.notifications.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "relative mb-3 rounded-md bg-greyLight p-4"
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(item.card_name), 1),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", null, "Списано: " + _toDisplayString(item.amount), 1),
                      (item.commission_withheld)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Отправлено: " + _toDisplayString(_ctx.mathCommission(item.amount, item.commission_withheld)), 1))
                        : _createCommentVNode("", true),
                      (item.commission_withheld)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Комиссия: " + _toDisplayString(item.commission_withheld), 1))
                        : _createCommentVNode("", true),
                      (item.partner_bank_name)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(`${item.partner_bank_name}`), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: _normalizeClass([
                _ctx.validateTransactionStatus(
                  item.status,
                  item.adapter_status,
                  'color',
                )
              , "flex w-full justify-center rounded-md py-1 px-2 text-sm text-white"])
                    }, _toDisplayString(_ctx.validateTransactionStatus(
                  item.status,
                  item.adapter_status,
                  "text",
                )), 3),
                    (
                (item.date_time && _ctx.isActiveContactParent(item.date_time)) ||
                item.status != 'IN_PROCESSING'
              )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          onClick: ($event: any) => (_ctx.validateNotComingMoney(item)),
                          class: "cursor-pointer mt-3 flex w-full items-center justify-center rounded-full bg-background py-1 px-2 text-sm text-blue"
                        }, [
                          (
                  item.status === 'PAID' ||
                  item.status === 'IN_PROCESSING' ||
                  item.status === 'ALLOW_TRANSACTION'
                )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Не получил "))
                            : _createCommentVNode("", true),
                          (
                  (item.status === 'ERROR' &&
                    (item.adapter_status === 'SUCCESS' ||
                      item.adapter_status === 'NULL' ||
                      item.adapter_status === 'FAILED')) ||
                  item.status === 'BLOCK_TRANSACTION'
                )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Почему? "))
                            : _createCommentVNode("", true),
                          (
                  item.status === 'ERROR' && item.adapter_status === 'REVERTED'
                )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Не вернулось "))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_10))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, _toDisplayString(item.card_number), 1),
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.formatDate(item.date_time)), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.isLoadData && _ctx.count <= 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, " У вас еще нет уведомлений, но они обязательно появятся "))
        : _createCommentVNode("", true),
      _createVNode(_component_confirm_modal, {
        state: _ctx.helpDialogModal,
        "confirm-button-text": _ctx.validateConfirmBtnText(),
        "decline-button-text": _ctx.validateDeclineBtnText(),
        htmlDescription: `${
        this.currentNotification?.status === 'ERROR' &&
        (this.currentNotification?.adapter_status === 'SUCCESS' ||
          this.currentNotification?.adapter_status === 'NULL' ||
          this.currentNotification?.adapter_status === 'FAILED')
          ? `${
              this.currentNotification?.adapter_status === 'SUCCESS'
                ? 'Деньги списались с баланса вашего кабинета.'
                : ''
            }
          ${
            this.currentNotification?.adapter_status === 'NULL' ||
            this.currentNotification?.adapter_status === 'FAILED'
              ? 'Деньги с баланса вашего кабинета <strong>НЕ СПИСАЛИСЬ</strong>.\n'
              : ''
          }  ${
              this.currentNotification?.status_description
                ? this.currentNotification?.status_description
                : ''
            }\n ${
              this.currentNotification?.status_payout ===
              'SCORE_NOT_ENOUGH_MONEY'
                ? ''
                : 'Если остались вопросы нажмите «Уточнить».\n Поддержка приложения работает с 10 до 22 по МСК.'
            } `
          : ''
      }${
        this.currentNotification?.status === 'ERROR' &&
        this.currentNotification?.adapter_status === 'REVERTED'
          ? `Деньги вернулись на баланс\n в Яндекс Про. ${
              this.currentNotification?.status_description
                ? this.currentNotification?.status_description
                : ''
            }\n Проверьте возврат средств, если возврата не произошло нажмите «Не получил» и свяжитесь с поддрежкой.\n Поддержка приложения работает с 10 до 22 по МСК. `
          : ''
      } ${
        this.currentNotification?.status === 'BLOCK_TRANSACTION'
          ? 'Транзакция на проверке в «Парке» (у партнера). Скоро статус исзменится, пожалуйста подождите.\n Если возникли вопросы нажмите «Уточнить».'
          : ''
      } ${
        this.currentNotification?.status === 'PAID' ||
        this.currentNotification?.status === 'ALLOW_TRANSACTION'
          ? 'Операция прошла успешно. Подождите минимум час и потом пришлите нам историю транзакции из приложения банка.\nЕсли транзакции там нет, дадим номер операции для поиска в вашем банке.'
          : ''
      }
       ${
         this.currentNotification?.status === 'IN_PROCESSING'
           ? 'Проведение платежа может затянуться. Пожалуйста подождите минимум час.\n Если возникли вопросы нажмите «Уточнить».'
           : ''
       }  `,
        onDecline: _cache[0] || (_cache[0] = ($event: any) => (_ctx.validateDeclineBtn())),
        onConfirm: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validateConfirmBtn()))
      }, null, 8, ["state", "confirm-button-text", "decline-button-text", "htmlDescription"]),
      _createVNode(_component_status_modal, {
        state: _ctx.statusModalDialog,
        "button-text": "Понял",
        description: _ctx.statusModalText,
        type: "warning",
        onConfirm: _cache[2] || (_cache[2] = ($event: any) => (_ctx.statusModalDialog = false))
      }, null, 8, ["state", "description"]),
      _createVNode(_component_status_modal, {
        state: _ctx.supportModalDialog,
        "button-text": "Отмена",
        description: 'Для связи с «Парком» вы можете:',
        type: "warning",
        onConfirm: _cache[3] || (_cache[3] = ($event: any) => (_ctx.supportModalDialog = false)),
        onWa: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sendWhatsAppPark())),
        onTm: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sendTelegramPark())),
        isSupportModal: true
      }, null, 8, ["state"]),
      (!_ctx.isLoadData)
        ? (_openBlock(), _createBlock(_component_notification_page_skeleton, { key: 2 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}